const GRADE_STYLES = {
  E18: "bg-brand-teal/10 text-brand-teal border-brand-teal/30",
  E25: "bg-brand-teal-dark/10 text-brand-teal-dark border-brand-teal-dark/30",
  E30: "bg-brand-teal-deep/10 text-brand-teal-deep border-brand-teal-deep/40",
  E40: "bg-brand-gold/15 text-[#8a6e1f] border-brand-gold/50",
  Organic: "bg-brand-green/10 text-brand-green border-brand-green/30",
  Analytical: "bg-brand-gold/15 text-[#8a6e1f] border-brand-gold/40",
};

export const GradeBadge = ({ grade, className = "" }) => {
  const style = GRADE_STYLES[grade] || GRADE_STYLES.E18;
  return (
    <span
      data-testid={`grade-badge-${grade}`}
      className={`inline-flex items-center font-mono text-[11px] uppercase tracking-[0.18em] px-3 py-1 border ${style} ${className}`}
    >
      Grade · {grade}
    </span>
  );
};

export default GradeBadge;
